import React, { FunctionComponent } from 'react';

export const CheckBadgeIcon: FunctionComponent = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48">
      <g
        stroke="#252B33"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        clip-path="url(#a)"
      >
        <path
          fill="#D09BFD"
          d="M21.46 2.714a3.26 3.26 0 0 1 5.08 0l3.024 3.762a3.258 3.258 0 0 0 2.892 1.2l4.8-.522a3.26 3.26 0 0 1 3.6 3.6l-.522 4.8a3.258 3.258 0 0 0 1.2 2.892l3.762 3.024a3.259 3.259 0 0 1 0 5.08l-3.774 3.01a3.265 3.265 0 0 0-1.2 2.894l.522 4.8a3.257 3.257 0 0 1-3.6 3.6l-4.8-.522a3.256 3.256 0 0 0-2.892 1.2L26.54 45.28a3.258 3.258 0 0 1-5.08 0l-3.022-3.76a3.261 3.261 0 0 0-2.894-1.2l-4.8.522a3.256 3.256 0 0 1-3.6-3.6l.522-4.8a3.262 3.262 0 0 0-1.2-2.894l-3.76-3.022a3.258 3.258 0 0 1 0-5.08l3.76-3.024a3.255 3.255 0 0 0 1.2-2.892l-.522-4.8a3.258 3.258 0 0 1 3.6-3.6l4.8.522a3.264 3.264 0 0 0 2.894-1.2l3.022-3.738Z"
        />
        <path d="m31.5 19.498-7.962 10.616a1.5 1.5 0 0 1-2.26.16L16.5 25.498" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h48v48H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
